
import React, { useState, useEffect } from 'react';
import { getMemberAnalytics } from '../api';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const ProgressTracker = ({ memberId }) => {
    const [analytics, setAnalytics] = useState(null);

    useEffect(() => {
        const fetchAnalytics = async () => {
            const response = await getMemberAnalytics(memberId);
            setAnalytics(response.data);
        };
        fetchAnalytics();
    }, [memberId]);

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Progress Tracker</h1>
            {analytics ? (
                Object.keys(analytics).map(exerciseName => (
                    <div key={exerciseName} className="mb-4">
                        <h2 className="text-xl font-semibold">{exerciseName}</h2>
                        <Line
                            data={{
                                labels: analytics[exerciseName].labels,
                                datasets: [
                                    {
                                        label: 'Reps Completed',
                                        data: analytics[exerciseName].reps,
                                        borderColor: 'rgba(75, 192, 192, 1)',
                                        fill: false,
                                    },
                                    {
                                        label: 'Weight Used',
                                        data: analytics[exerciseName].weight,
                                        borderColor: 'rgba(255, 99, 132, 1)',
                                        fill: false,
                                    },
                                ],
                            }}
                        />
                    </div>
                ))
            ) : (
                <p>Loading analytics...</p>
            )}
        </div>
    );
};

export default ProgressTracker;
